exports = module.exports = typeof Object.keys === 'function'
  ? Object.keys : shim;

exports.shim = shim;
function shim (obj) {
  var keys = [];
  for (var key in obj) keys.push(key);
  return keys;
}



//////////////////
// WEBPACK FOOTER
// /Users/sthzg/Development/sthzgnet-commons/~/deep-equal/lib/keys.js
// module id = 80
// module chunks = 35316943233537 85567699863870 213534597649335